import { Button } from '@/components/ui/Button';
import { ButtonLink } from '@/components/ui/Link';
import {
  Popover,
  PopoverContent,
  PopoverTrigger,
} from '@/components/ui/Popover';
import { Site } from '@/generated/graphql';
import { UserData } from '@/models/site.models';
import { createSortingButton } from '@/utils/table.function';
import { ColumnDef } from '@tanstack/react-table';
import { FileText, Navigation } from 'lucide-react';

export const siteColumns: ColumnDef<Site>[] = [
  {
    accessorKey: 'name',
    header: ({ column }) => {
      return createSortingButton(column, 'Name');
    },
    size: 300,
  },
  {
    accessorKey: 'customer',
    header: ({ column }) => {
      return createSortingButton(column, 'Customer');
    },
    cell: ({ row }) => row.original.customer?.name,
    size: 200,
  },
  {
    accessorKey: 'notes',
    header: 'Notes',
    cell: ({ row }) => {
      const userData = row.original.userData as UserData | null;
      const notes = userData?.notes;
      if (!notes) return null;
      return (
        <Popover>
          <PopoverTrigger asChild>
            <Button variant="outline" size="sm">
              <FileText className="h-4 w-4" />
            </Button>
          </PopoverTrigger>
          <PopoverContent align="end" className="max-h-64 w-96 overflow-auto">
            <pre className="text-xs break-all whitespace-pre-wrap">
              {JSON.stringify(notes.data, null, 2)}
            </pre>
          </PopoverContent>
        </Popover>
      );
    },
    size: 80,
  },
  {
    accessorKey: 'action',
    header: '',
    cell: ({ row }) => (
      <ButtonLink
        variant="outline"
        size={'icon-sm'}
        className="ms-auto flex"
        to={`${row.original.id}`}
      >
        <Navigation />
      </ButtonLink>
    ),
  },
];
